import { render, staticRenderFns } from "./PromotionsList.vue?vue&type=template&id=921c0bc2&"
import script from "./PromotionsList.vue?vue&type=script&lang=js&"
export * from "./PromotionsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('921c0bc2')) {
      api.createRecord('921c0bc2', component.options)
    } else {
      api.reload('921c0bc2', component.options)
    }
    module.hot.accept("./PromotionsList.vue?vue&type=template&id=921c0bc2&", function () {
      api.rerender('921c0bc2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Promo/list/PromotionsList.vue"
export default component.exports